'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGContainer = require('../SVGContainer');

var _SVGContainer2 = _interopRequireDefault(_SVGContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FreehandIcon = function FreehandIcon(props) {
  return _react2.default.createElement(
    _SVGContainer2.default,
    props,
    _react2.default.createElement('path', { d: 'M4.16661785,12.1382028 C4.11689964,12.3503701 4.06589728,12.5655144 3.99525109,12.8617398 C3.3033144,15.7630885 3.10178005,16.7417019 3.02034298,17.9673652 C2.89295412,19.8846229 3.3574021,21.2118016 4.75072573,21.7113454 C6.92419023,22.4905905 8.27618058,21.1506649 9.86226347,17.9350518 C10.0975777,17.4579774 10.9019695,15.746399 11.0101437,15.5216955 C12.8015164,11.8005895 14.2103875,10.2346499 16.2465831,10.281747 C17.9830458,10.3219112 19.7430025,11.908937 20.5023201,14.3179044 C21.4044795,17.1800434 20.7915902,20.6404615 18.4317277,24.0134808 C16.6280973,26.5914617 15.2096767,27.337786 14.4152038,26.8761468 C13.6393829,26.4253456 13.1768,24.8053858 13.4752462,22.9933101 C14.314324,17.8986812 19.1984785,15.6753858 27.3295502,19.5093988 L28.1825331,17.7004156 C18.8983982,13.3227032 12.5663091,16.2051068 11.5018321,22.6682917 C11.0828754,25.2120714 11.7815939,27.6589755 13.4103918,28.6054105 C15.358934,29.7376372 17.7468798,28.4811821 20.0704771,25.1599976 C22.7774273,21.2908757 23.5040633,17.1882354 22.4098055,13.7166562 C21.4116491,10.5499628 18.9654221,8.34409863 16.2928307,8.28228174 C13.1674127,8.209991 11.324005,10.2589116 9.20808904,14.6541708 C9.09242855,14.8944251 8.29381311,16.5937127 8.06858836,17.0503318 C6.91291818,19.3933292 6.1952528,20.1045904 5.42570868,19.8286882 C4.72898435,19.5788939 4.83696661,17.9537139 5.94069124,13.3257038 C6.0118939,13.0271451 6.06343526,12.8097271 6.1138678,12.5945115 C6.71495397,10.0294387 6.97449205,8.45377203 6.93191498,7.03012973 C6.87067979,4.98261918 6.08090908,3.55621192 4.37764696,3.04258448 L3.80021983,4.95741552 C5.21276819,5.38337673 5.27351703,7.41462547 4.16661785,12.1382028 Z' })
  );
};

FreehandIcon.propTypes = {
  size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
};

exports.default = FreehandIcon;